module.exports = __webpack_public_path__ + "img/d_zjc.bab18723.jpg";